export const HEADERS = {
  contentType: 'application/json',
  xOrdApi: '8e0d369edfc240d7960e2fd778c10162',
  xOrdService: '7d2b33dd25ef43c0b94443eaa22c19b1',
  xOrdService2: '57bfb26735aa4ec3a1baafa864006d7d',
  xOrdChannel: '682630a0db7342a7a45e748f76cf1f16',
};

export const INCODE_HEADERS_PROD = {
  company: 'c5597120a65044ee8940cb4819344428',
  channel: '94de241c29234d64bbd944ff3df690e1',
  service: 'c57a116e2e264921803487355b7534d6',
};

export const ENDPOINTS = {
  hiring: {
    dnValidate: '/comunications/sms/otp/request',
    dnValidate2: '/notifications/v1/sms/services/otp/generate',
    otpValidate: '/comunications/sms/otp/',
    ORD_SERVICE_HEADER: 'ordServicio',
    IMEI: '/public/verification/imei/compatibility',
    cpSearch: '/directions/v1/address',
    offeringList: '/public/offering/list',
    baitLineValidation: '/public/verification/dn/line-status',
    saveClientData: '/public/client/save-data',
    savePortabilityClientData: '/public/client/portability-form',
    dnPerfil: 'public/bait/perfil-dn',
    clientInfo: '/public/information',
    dnProfile: '/public/verification/mbb/get-by-',
    contractAssign: '/contract/assign',
    pdfContract: '/public/contract/',
    validateStepIncode: '/services/api/v1/verify/status-onboarding',
    loginIncode: '/public/login',
    portInForm: '/public/contract/port-in-form',
    otpPortability: '/comunications/sms/otp/',
    loginToSwitch: '/api/login',
    switchPaymentOption: '/private/contract/management/price',
    migratedContract: '/webhook/payment/migrated/charge-not-applied',

    newContract: '/webhook/payment/new/charge-not-applied',
    esimContract: '/webhook/payment/esim/charge-not-applied',
  },
  billing: {
    validateDnBill: '/public/client/dn/search-in-contract',
    billResume: '/public/contract/get-bill',
  },
};

export const TRACKING_IDS = {
  meta: '1109874953317214',
  tiktok: 'CLSBT5JC77U7LBPUSSJ0',
};
